import { formatShortThaiDate } from '../../utils/dateUtils';

interface TimeStatProps {
  targetDate?: Date | null;
  completedDate: string | null;
  createdAt?: string;
}

export const TimeStat: React.FC<TimeStatProps> = ({ targetDate, completedDate, createdAt }) => {
  const countdownColor = 'text-green-500';
  return (
    <div className="p-4 rounded-lg flex items-center justify-between gap-5">
      <div>
        {targetDate ? (
          <>
            <p className="text-sm text-gray-600">กำหนดเสร็จภายใน</p>
            <p className="text-lg font-semibold">
              {formatShortThaiDate(targetDate)}
            </p>
          </>
        ) : createdAt ? (
          <>
            <p className="text-sm text-gray-600">วันที่สร้างใบงาน</p>
            <p className="text-lg font-semibold">
              {formatShortThaiDate(new Date(createdAt))}
            </p>
          </>
        ) : null}
      </div>
      {completedDate && <div className="text-right">
        <p className="text-sm text-gray-600">ปิดใบงานเมื่อ</p>
        <p className={`text-lg font-bold ${countdownColor}`}>
            <span>{formatShortThaiDate(new Date(completedDate))}</span>
        </p>
      </div>}
    </div>
  );
};

export default TimeStat;
